<div class="flixbus-promotion-backdrop" @fadeIn (click)="close()" *ngIf="isVisible">
  <div class="flixbus-promotion-modal" (click)="$event.stopPropagation()">
    <div class="close-button-wrapper" (click)="close()">
      <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/x.svg"></svg-icon>
    </div>
    
    <div class="promotion-header">
      <div class="flixbus-logo">
        <img src="/assets/icons/flixbus_logo.svg" alt="FlixBus Logo">
      </div>
    </div>

    <div class="promotion-content">
      <h2 class="promotion-title">
        <ng-container i18n>Get 10% Off Your Next FlixBus Ride 🚍</ng-container>
      </h2>
      <p class="promotion-description">
        <ng-container i18n>Book your hostel with HostelHop and receive your exclusive discount code.</ng-container>
      </p>
    </div>

    <div class="promotion-actions">
      <button class="btn-book" (click)="close()">
        <ng-container i18n>👉 Book Now</ng-container>
      </button>
    </div>
  </div>
</div>
